// This file was extracted from `src/rxdb/syncReplicationStatesWithGraphQL.ts`
import { CheckpointType } from '../types';
import { PullResponseModifier } from './replicate';

export const pullResponseModifier: PullResponseModifier<unknown> = (
  plainResponse,
  _origin,
  requestCheckpoint,
) => {
  const lastDoc = plainResponse.length === 0 ? null : plainResponse[plainResponse.length - 1];

  let checkpoint: CheckpointType;
  if (plainResponse.length === 0) {
    // The RxDB docs suggest that we should return `requestCheckpoint` if there are no documents.
    // However, the types (at least under RxDB v14) do not allow this, as
    // `requestCheckpoint` can be `undefined`, but the return checkpoint may not be.
    // https://rxdb.info/replication-graphql.html#pushresponsemodifier
    checkpoint = requestCheckpoint || {
      id: '',
      updatedAt: 0,
    };
  } else {
    checkpoint = {
      id: lastDoc.id,
      updatedAt: lastDoc.updatedAt,
    };
  }

  const result = {
    documents: plainResponse,
    checkpoint,
  };

  return result;
};
